import gql from "graphql-tag";
import CompanyIssuerFields from "lib/graphql/fragments/CompanyIssuerFields";
const SelectedCompaniesHistoryQuery = gql`
  query SelectedCompaniesHistory {
    selectedCompaniesHistory {
      ...CompanyIssuerFields
    }
  }
  ${CompanyIssuerFields}
`;
export default SelectedCompaniesHistoryQuery;
